module.exports = __webpack_public_path__ + "assets/img/5_1186_big.e857250a.jpg";